import { UserLabel } from '@app/components/users/UserLabel';
import { FragmentListItemDto } from '@app/modules/fragments/fragment.types';
import { Typography } from '@mui/material';

/**
 * Renders the fragment creator: user label and optional dot separator.
 * Renders nothing when fragment has no creator (undefined or null).
 */
export function FragmentCardCreator({
  creator,
}: {
  creator: FragmentListItemDto['creator'] | null;
}) {
  if (!creator) return null;

  return (
    <>
      <Typography variant="caption" color="text.secondary">
        <UserLabel
          showIcon
          id={creator.id}
          user={{
            name: creator.name ?? '',
            surname: creator.surname ?? '',
            email: creator.email ?? '',
          }}
        />
      </Typography>
      <Typography variant="caption" color="text.secondary">
        ·
      </Typography>
    </>
  );
}
